import { Injectable } from '@angular/core';
import { LoggerFactory, Logger } from '../../core/logger.service';
import { TriggerbeeApi } from 'app/core/triggerbee/triggerbee-requester.service';
import { SignInResultType } from './sign-in-result';
import { HttpRequestDecorator } from 'app/core/triggerbee/http.request.decorator';
import { Observable } from 'rxjs';

@Injectable()
export class SignInService {
  private readonly logger: Logger;

  constructor(
    loggerFactory: LoggerFactory,
    private readonly http: HttpRequestDecorator,
  ) {
    this.logger = loggerFactory.get('SignInService');
  }

  public login(email: string, password: string): Observable<AuthenticationGatewayResponse> {
    if (!email) {
      this.logger.error('Email is null or empty');
      return undefined;
    }
    if (!password) {
      this.logger.error('Password is null or empty');
      return undefined;
    }
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/authentication/email/login`;
    return this.http.post(url, { email: email, password: password });
  }

  public verifyTotp(email: string, code: string): Observable<AuthenticationGatewayResponse> {
    if (!email) {
      this.logger.error('Email is null or empty');
      return undefined;
    }
    if (!code) {
      this.logger.error('Code is null or empty');
      return undefined;
    }
    const url = this.http.getBaseUrl(TriggerbeeApi.Gateway) + `/authentication/totp/verify-login`;
    return this.http.post(url, { email: email, code: code });
  }
}

export interface AuthenticationGatewayResponse {
  authResult: SignInResultType;
  error: string;
  statusCode: number;
}
